import { collection, getDocs } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { db } from "../Firebase";
import Loading from "./Loading";

const ReactTab = () => {
  const [reactprjct, setReactprjct] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getReactData() {
    setLoading(true);
    const querySnap = await getDocs(collection(db, "reactProjects"));
    setReactprjct(
      querySnap.docs.map((doc) => {
        return {
          id: doc.id,
          data: doc.data(),
        };
      })
    );
    setLoading(false);
  }

  useEffect(() => {
    getReactData();
  }, []);

  if (loading === true) {
    return <Loading />;
  }

  return (
    <div className="flex justify-center">
      <div className="grid gap-4 lg:grid-cols-4">
        {reactprjct.map((item) => (
          <div className="max-w-sm bg-slate-800 rounded-lg overflow-hidden shadow-lg border-2 border-blue-500 shadow-blue-900">
            <img
              className="w-full h-60 object-fill"
              src={item.data.img}
              alt=""
            />
            <div className="flex flex-col p-3 space-y-4">
              <a href={item.data.url} rel="noreferrer" target="_blank">
                <strong className="">{item.data.name}</strong>
              </a>
              <small>
                {item.data.details}
                <details close>
                  <summary className="cursor-pointer">Tools</summary>
                  <ol className="px-6">
                    <li>{item.data.tool1}</li>
                    <li>{item.data.tool2}</li>
                    <li>{item.data.tool3}</li>
                    <li>{item.data.tool4}</li>
                    <li>{item.data.tool5}</li>
                    <li>{item.data.tool6}</li>
                    <li>{item.data.tool7}</li>
                    <li>{item.data.tool8}</li>
                  </ol>
                </details>
              </small>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReactTab;
